import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import DocumentTitle from 'react-document-title'
import { config } from 'config'

import SiteHeader from '../../components/SiteHeader'

export default class GettingStarted extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render () {
    let landingImage = "/images/landing-img.svg";

    return (
      <DocumentTitle title={config.gettingStartedTitle}>
      <div className="GettingStarted">

        <SiteHeader />

        <div className="hero">

        </div>

        <div className="SetterBase-spacer"></div>
        <div className="SetterBase-row">
          <div className="SetterBase-c-4 SetterBase-col text-center"><span className="invis">a</span></div>
          <div className="SetterBase-c-8 SetterBase-col text-center">

            {/*<span className="divider"></span>*/}
          </div>
        </div>
        <div className="SetterBase-spacer"></div>
        <div className="SetterBase-row get-started">
          <div className="SetterBase-c-4 SetterBase-col m-hide">
            <ul>
              <li><a href="#intro">Intro</a></li>
              <li><a href="#create-account">Create an Account</a></li>
              <li><a href="#create-team">Create a Team</a></li>
              <li><a href="#invite-team">Invite Your Team</a></li>
              <li><a href="#create-buckets">Create Some Buckets</a></li>
              <li><a href="#add-person">Add a Person</a></li>
              <li><a href="#tags">Tags</a></li>
              <li><a href="#download-extension">Download the Chrome Extension</a></li>
              <li><a href="#searching-name">Searching by Name</a></li>
              <li><a href="#filtering-people">Filtering People</a></li>
              <li><a href="#snoozing">Snoozing</a></li>
              <li><a href="#archiving">Archiving</a></li>
              <li><a href="#connect-ats">Connect your ATS</a></li>
              <li><a href="#permissions">Permissions</a></li>
              {/*<li><a href="#add-sources">Add Sources</a></li>*/}
              <li><a href="#help">Help</a></li>
            </ul>
          </div>
          <div className="SetterBase-medium-c-8 SetterBase-col">
            <div className="text-box" id="intro">
              <h2 className="get-title">Quick Start Guide</h2>
              <p>Welcome to Setter! Now, let’s get you started using it.<br></br><br></br>

Setter is fundamentally a CRM built specifically for those in the world of recruiting and talent acquisition. Because of this focus implementing Setter is relatively simple.</p>
            </div>

            <div className="text-box" id="create-account">
              <h4 className="title-section">Create an Account</h4>
              <p>If you are reading this then you probably already have an account. If not you should learn more <a href="http://www.setter.io">here</a>. If you have been invited by someone then you should use the link you received in your email to Sign Up for an account. Using the provided email will ensure you join the team.</p>

            </div>

            <div className="text-box" id="create-team">
              <h4 className="title-section">Create a Team</h4>
              <p>After you first create your account the first thing you have to do is name your team, if you are joining an existing team you won’t see this step.</p>
              <div className="img-box"><img src="../images/get-started/Create Team - Empty.png"/></div>
            </div>

            <div className="text-box" id="invite-team">
              <h4 className="title-section">Invite Your Team</h4>
              <p>Once you are logged in to your account a great place to start is to invite your team to join the party. You can do this from the <a href="http://app.setter.io/account/team" target="_blank">Manage Team</a> page. Simply input their email address and hit Send Invite. They will then receive an email saying that you have invited them to join the team. Once they click the link in their email they will be able to create an account and will be automatically added to the team. Anyone on the team can send invites.</p>
              <div className="img-box"><img src="../images/get-started/Manage Team - Empty.png"/></div>
            </div>

            <div className="text-box" id="create-buckets">
              <h4 className="title-section">Create Some Buckets</h4>
              <p>Setter has a few ways for you to categorize People. One of the primary ways is by using Buckets. You may have a Bucket called Software Engineers, or even more specifically Java Engineers, or a Bucket for Referrals, or like us one called Interesting People.<br></br><br></br>

We took the liberty of creating 2 sample Buckets for you (Referrals and Software Engineers). Feel free to delete these.<br></br><br></br>

Go ahead and <a href="http://app.setter.io/buckets" target="_blank">create a Bucket or two</a> of your own.<br></br><br></br>

Over time the view of an individual Bucket will evolve based on your feedback.</p>
              <div className="img-box"><img src="../images/get-started/Buckets View - Click Add Bucket.png"/></div>
              <div className="img-box"><img src="../images/get-started/Buckets View - Add Bucket Modal.png"/></div>

              <p><br/><br/>If you would like to delete one of the sample Buckets.</p>

              <div className="img-box"><img src="../images/get-started/Buckets View - Click Edit Bucket.png"/></div>
              <div className="img-box"><img src="../images/get-started/Buckets View - Click Delete Bucket.png"/></div>

            </div>

            <div className="text-box" id="add-person">
              <h4 className="title-section">Add a Person</h4>
              <p>Setter is focused around People, so let’s create our first Person now! The nice big green New Person button is always visible so you can always get to it.<br></br><br></br>

You will notice that there is only one field for name called Full Name. This makes it easier to copy and paste a name in from somewhere else rather than breaking it up into First and Last name fields. Setter is smart enough to figure out which name is which.<br></br><br></br>

This form is also Tab smart, which means you can keep your hands on the keyboard as you enter someone’s info.</p>
              <div className="img-box"><img src="../images/get-started/New Person - Empty.png"/></div>
            </div>

            <div className="text-box" id="tags">
              <h4 className="title-section">Tags</h4>
              <p>Tags are useful for filtering People. Use them however you like! Use the Add Tag link under the Tags field on a Person to add a Tag does not exist yet.</p>

            </div>

            <div className="text-box" id="download-extension">
              <h4 className="title-section">Download the Chrome Extension</h4>
              <p>Most of the time when you think of or come across a Person you want to have in Setter you are not on the Setter tab. For all those other tabs we have the Setter Chrome Extension.<br></br><br></br>

You can find a link to the Chrome Extension on the <a href="http://app.setter.io/account/profile" target="_blank">Account</a> page.<br></br><br></br></p>

              <div className="img-box"><img src="../images/get-started/Manage Account - Click Chrome Extension.png"/></div>
<p>
<b>Using the Chrome Extension</b><br></br><br></br>
The Chrome Extension plays nicely with others and likes to help you out as much as possible with things like auto-populating information. Name, Email, Location, etc. We will be adding supported sites over time so if you have a favorite you’d like to see added please let us know at <b>support@setter.io</b>.<br></br><br></br>

If you are on a site that Setter does not recognize you can click on the empty Profile picture to put it into selection mode. You can then click on an image from the page to make it that Person’s profile picture. Handy!<br></br><br></br>

If you are on a page Setter recognizes and it finds the Name of someone already in your database it will let you know so that you don’t enter the same person twice. You can also use this as a quick way to Edit a Person in Setter. For example you manually entered a Person in Setter then you go to their LinkedIn page and you’d like to include more info about them you can quickly click the Setter Chrome Extension and then Edit that Person.<br></br><br></br>

You can also Search for People in your Setter database from the Chrome Extension, this is another useful way for editing/viewing a Person while not being on the Setter tab.</p>

            </div>

            <div className="text-box" id="searching-name">
              <h4 className="title-section">Searching by Name</h4>
              <p>The simplest way to get back to that Person you were just thinking of, assuming you remember part of the name that is. Click on the Search icon in the nav bar and then start typing a name. The list will automatically update as you type. The search results will include Snoozed and Archived People.</p>

            </div>

            <div className="text-box" id="filtering-people">
              <h4 className="title-section">Filtering People</h4>
              <p>Sometimes you really need a good filter. Luckily Setter has a very nice one. On the <a href="http://app.setter.io/people" target="_blank">People</a> view click on Add Filter and you will be able to choose from a variety of options to filter down to just what you are looking for.</p>
              <div className="img-box"><img src="../images/get-started/Filter View - Empty.png"/></div>
              <div className="img-box"><img src="../images/get-started/Filter View - Click Apply Filter.png"/></div>

              <p><br></br><br></br>
You can also remove individual filters to open things back up.</p>
              <div className="img-box"><img src="../images/get-started/Filter View - Click Remove Filter.png"/></div>
            </div>

            <div className="text-box" id="snoozing">
              <h4 className="title-section">Snoozing</h4>
              <p>You can think of Snoozing as a reminder to follow up with someone or to just put them back on your radar. We have made it simple to choose how long to Snooze a Person, with sensible defaults and the ability to choose from a calendar or type in a date manually.<br></br><br></br>

Very soon you will be able to customize the notifications you receive when a Person reaches the end of their Snooze. Email and Slack notifications coming first.</p>
              <div className="img-box"><img src="../images/get-started/People View - Click Snooze.png"/></div>
            </div>

            <div className="text-box" id="archiving">
              <h4 className="title-section">Archiving</h4>
              <p>The Archive is where you put a Person you no longer wish to see in your lists but that you still want in the Setter database for future reference. These could be People who have said, "no thanks", that you have ruled out, or that you have actually hired.</p>

            </div>

            <div className="text-box" id="connect-ats">
              <h4 className="title-section">Connect your ATS</h4>
              <p>Setter currently supports Greenhouse. Each user on your team should individually connect Greenhouse so that Greenhouse can know who is submitting a Person from Setter.<br></br><br></br>

To connect Greenhouse you can go to the <a href="http://app.setter.io/account/profile" target="_blank">Account</a> view and choose Connect Greenhouse. This will redirect you to Greenhouse where you will have to log in if you are not already logged in and then choose to Authorize Setter.<br></br><br></br>

You can now Submit a Person to Greenhouse from their profile view.</p>
              <div className="img-box"><img src="../images/get-started/Manage Account - Click Connect Greenhouse.png"/></div>
            </div>

            <div className="text-box" id="permissions">
              <h4 className="title-section">Permissions</h4>
              <p>Setter is designed for small teams and as such does not currently have a granular permissions system. If this is extremely important to you please let us know at <b>support@setter.io</b>.</p>
            </div>

            <div className="text-box" id="help">
              <h4 className="title-section">Help</h4>
              <p>If you need any help getting set up please let us know at  <b>support@setter.io</b>.</p>
            </div>

            {/*<div className="text-box" id="add-sources">
              <h4 className="title-section">Add Sources</h4>
              <p>Sources are great for keeping track of where a Person came from. Whether it be from a consistent referral partner or from a networking group you attend frequently. To add a Source you click on Sources in the sidebar, then you can add, edit, and delete Sources. Editing a Source name will be automatically reflected on each Person’s profile and if you delete a Source it will be removed from each Person.</p>
            </div>*/}

          </div>
        </div>

        <div className="SetterBase-spacer-giant"></div>

      </div>
      </DocumentTitle>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./getting-started/index.js
 **/